export const FETCH_STAFF_LOGIN_REQUEST = 'FETCH_STAFF_LOGIN_REQUEST';
export const FETCH_STAFF_LOGIN_FAILURE = 'FETCH_STAFF_LOGIN_FAILURE';
export const FETCH_STAFF_LOGIN_SUCCESS = 'FETCH_STAFF_LOGIN_SUCCESS';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const USER_STAFF_LOGOUT = 'USER_STAFF_LOGOUT';
